module.exports = __webpack_public_path__ + "static/media/bear3.7a05dd48.jpg";